module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    staticClass: "icon",
    attrs: {
      "transform": _vm.transform
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showList($event)
      }
    }
  }, [_c('use', {
    attrs: {
      "x": "0",
      "y": "0",
      "width": _vm.visualizationPinSize.width,
      "height": _vm.visualizationPinSize.height,
      "fill": _vm.visualizationPinColor,
      "transform": _vm.visualizationPinTransform,
      "xlink:href": "#pin-person"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "number",
    attrs: {
      "transform": _vm.numberPosition
    }
  }, [_c('circle', {
    attrs: {
      "cx": "0",
      "cy": "0",
      "r": _vm.numberRadius,
      "stroke-width": _vm.numberRadius / 32,
      "fill": "#fff",
      "stroke": "#6c6c6c"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "0",
      "y": "0",
      "dy": _vm.textSize * 35 / 100,
      "font-size": _vm.textSize,
      "font-weight": "bold",
      "fill": "#6c6c6c",
      "text-anchor": "middle"
    }
  }, [_vm._v(_vm._s(_vm.persons.length) + _vm._s(_vm.persons.length > 9 ? '+' : ''))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c82bfb70","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/visualization/pin/person/multiple.vue
// module id = 755
// module chunks = 0